/**
 * @changelog
 *
 * 2026-03-24 (0.1.0) (jhoward)
 *   - Add getRouteWithFixedUrl helper to strip protocol/host from route URLs.
 *
 * 2026-04-09 (0.1.1) (jhoward)
 *   - Fix getRouteWithFixedUrl to only parse URLs starting with //.
 *
 * 2026-09-10 (0.1.3) (jhoward)
 *   - Say plainly that this does nothing now, and drop the commented-out body it was saying it with. AGENTS.md
 *     still described it as stripping protocol and host, which it has not done since 2026-09-08.
 */

import type { Method, RouteDefinition } from '@framework/defs/wayfinder';

/**
 * Returns the route unchanged.
 *
 * It used to strip the protocol and host off a wayfinder URL, which arrived looking like
 * //dev.opc.peppermillresorts.com/login and could not be fetched as-is. Wayfinder stopped emitting those on
 * 2026-09-08 and the body was commented out then.
 *
 * Kept, rather than deleted from its dozen call sites, as the one seam to put the fix back into if the upstream
 * behaviour ever returns - there is nowhere else that every outgoing route URL passes through. It is a pass-through
 * today, so nothing should depend on it normalising anything; if the seam stops earning its place, deleting it is a
 * mechanical change at every call site.
 */
export default function getRouteWithFixedUrl(route: RouteDefinition<Method>): RouteDefinition<Method> {
  return route;
}
